export const LEAD_STATUSES = [
  'new_contact',
  'follow_up',
  'working',
  'quote',
  'quote_sent',
  'meeting',
  'negotiation',
  'contract_signed',
  'closed_lost',
] as const;

export type LeadStatus = (typeof LEAD_STATUSES)[number];

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  new_contact: 'Nowy Kontakt',
  follow_up: 'Ponowić kontakt',
  working: 'Robocze',
  quote: 'Wycena w przygotowaniu',
  quote_sent: 'Wycena wysłana',
  meeting: 'Spotkanie',
  negotiation: 'Negocjacje',
  contract_signed: 'Podpisanie umowy',
  closed_lost: 'Zamknięte - brak umowy',
};

/**
 * Tailwind kolory dla badge'ow i kanban kolumn (z palety shadcn).
 */
export const LEAD_STATUS_COLORS: Record<LeadStatus, string> = {
  new_contact: 'blue',
  follow_up: 'cyan',
  working: 'slate',
  quote: 'amber',
  quote_sent: 'yellow',
  meeting: 'violet',
  negotiation: 'orange',
  contract_signed: 'emerald',
  closed_lost: 'rose',
};

/**
 * Statusy ktore oznaczaja "lead zamkniety" — nie pojawiaja sie w aktywnym pipelinie.
 */
export const CLOSED_STATUSES = [
  'contract_signed',
  'closed_lost',
] as const satisfies readonly LeadStatus[];

export function isClosedStatus(status: LeadStatus): boolean {
  return (CLOSED_STATUSES as readonly LeadStatus[]).includes(status);
}
